import { ToastProps } from 'ps-shared-ui/v4/Toast';
import axios from 'ps-components/lib/apiClient';
import { Dispatch } from 'react';
import { TOAST_SUCCESS_OPTIONS, TOAST_ERROR_OPTIONS } from '../../../../../constants';
import { US_STATES_WITH_ABBR } from "../../../../../constants/USStates";
import { USState, USStateAbbreviated } from "../../../../../lib/types";
import { MinimumWageReducerAction, MinimumWageTableI } from './store';

export const stateAbbrToName = (stateAbbr: USStateAbbreviated): USState => (US_STATES_WITH_ABBR.find(state => state.value === stateAbbr)?.label) as USState
export const stateNameToAbbr = (stateName: USState): USStateAbbreviated => (US_STATES_WITH_ABBR.find(state => state.label === stateName)?.value) as USStateAbbreviated
export const formatDate = (date: Date | string) => date ? date.toString().split('T')[0] : ''
export const formatCalDate = (date: Date | string) => {
  if (!date) return ''
  const [mm, dd, yyyy] = new Date(date).toLocaleDateString('en-US').split('/')
  const month = mm.length === 1 ? `0${mm}` : mm
  const day = dd.length === 1 ? `0${dd}` : dd
  const newDate = `${yyyy}-${month}-${day}`
  return newDate
}

//TODO: Create Interface to extend axios with our custom methods OR create a new axios instance to use moving forward
export const getMininumWages = async (dispatch: Dispatch<MinimumWageReducerAction>) => {
  dispatch({ type: 'SET_REQUEST_PENDING', payload: true })
  try {
    const { data } = await (axios as any).apiGet('/api/marketpay-internal/minimum-wage/getMinimumWages')
    dispatch({ type: 'SET_ROWS', payload: data.results.rows })
    dispatch({ type: 'SET_REQUEST_PENDING', payload: false })
  } catch (err) {
    console.error(err)
    dispatch({ type: 'SET_REQUEST_PENDING', payload: false })
  }
}

export const addMinimumWage = async (
  dispatch: Dispatch<MinimumWageReducerAction>,
  { state, city, minimum_wage, effective_date }: MinimumWageTableI,
  toast: (message: React.ReactNode, props: ToastProps) => any
) => {

  dispatch({ type: 'SET_REQUEST_PENDING', payload: true })
  try {
    const { data } = await (axios as any).apiPost(`/api/marketpay-internal/minimum-wage/addMinimumWage`, { state, city, minimum_wage, effective_date })
    if (data.results.rowCount > 0) {
      toast(`Minimum wage successfully added for ${!!city ? city + ',' : ''} ${stateAbbrToName(state)}`, TOAST_SUCCESS_OPTIONS)
      dispatch({ type: 'MINIMUM_WAGE_ADDED' })
    } else {
      toast('Error adding minimum wage', TOAST_ERROR_OPTIONS)
    }
    dispatch({ type: 'SET_REQUEST_PENDING', payload: false })
  } catch (err) {
    toast('Error adding minimum wage', TOAST_ERROR_OPTIONS)
    console.error(err)
    dispatch({ type: 'SET_REQUEST_PENDING', payload: false })
  }
  dispatch({ type: 'SET_MODAL_CLOSED' })
}


export const editMinimumWage = async (
  formState: MinimumWageTableI,
  selectedRow: MinimumWageTableI,
  dispatch: Dispatch<MinimumWageReducerAction>,
  toast: (message: React.ReactNode, props: ToastProps) => any
) => {
  const { state, city, minimum_wage, effective_date } = formState
  const set = { state, city, minimum_wage: parseFloat(minimum_wage as string).toFixed(2), effective_date: new Date(effective_date).toISOString() }
  const where = { state: selectedRow.state, city: selectedRow.city, minimum_wage: selectedRow.minimum_wage, effective_date: selectedRow.effective_date }

  dispatch({ type: 'SET_REQUEST_PENDING', payload: true })

  try {
    const { data } = await (axios as any).apiPost(`/api/marketpay-internal/minimum-wage/editMinimumWage`, { set, where })
    if (data?.results?.rowCount > 0) {
      toast(`Minimum wage successfully updated for ${!!city ? city + ',' : ''} ${stateAbbrToName(state)}`, TOAST_SUCCESS_OPTIONS)
      getMininumWages(dispatch)
    } else {
      toast('Error updating minimum wage', TOAST_ERROR_OPTIONS)
    }
    dispatch({ type: 'SET_REQUEST_PENDING', payload: false })
  } catch (err) {
    console.error('Error updating minimum wage: ', err)
    toast('Error updating minimum wage', TOAST_ERROR_OPTIONS)
    dispatch({ type: 'SET_REQUEST_PENDING', payload: false })
  }

  dispatch({ type: 'SET_MODAL_CLOSED' })
}

export const deleteMinimumWage = async (
  tableDispatch: Dispatch<MinimumWageReducerAction>,
  { state, city, minimum_wage, effective_date }: MinimumWageTableI,
  toast: (message: React.ReactNode, props: ToastProps) => any
) => {
  tableDispatch({ type: 'SET_REQUEST_PENDING', payload: true })

  try {
    const { data } = await (axios as any).apiPost(`/api/marketpay-internal/minimum-wage/deleteMinimumWage`, { state, city, minimum_wage, effective_date })
    if (data.results.rowCount > 0) {
      toast('Minimum wage was successfully deleted', {
        duration: 3000,
        isCloseable: false,
        type: 'success'
      })
      getMininumWages(tableDispatch)
    } else {
      toast('Error deleting minimum wage', {
        duration: 3000,
        isCloseable: false,
        type: 'error'
      })
    }
    tableDispatch({ type: 'SET_REQUEST_PENDING', payload: false })
  } catch (err) {
    console.error(err)
    toast('Error deleting minimum wage', {
      duration: 3000,
      isCloseable: false,
      type: 'error'
    })
    tableDispatch({ type: 'SET_REQUEST_PENDING', payload: false })
  }
  tableDispatch({ type: 'SET_MODAL_CLOSED' })
}
